import clsx from 'clsx';
import isFunction from 'lodash/isFunction';
import { type CSSProperties, type FC } from 'react';

import styles from './index.module.scss';

export const Modal: FC<OverlayProps> = ((props) => {
  const { show = false, onClick, backgroundColor, style, ...otherProps } = props;

  return (
    <div
      className={clsx(styles.overlay, { [styles.show]: show })}
      onClick={isFunction(onClick) ? onClick : undefined}
      style={{ backgroundColor, ...style }}
      {...otherProps}
    />
  );
});

export interface OverlayProps {
  show?: boolean;
  onClick?: () => void;
  backgroundColor?: string;
  style?: CSSProperties;
}
